export default __webpack_public_path__ + "static/media/YFIe.5a75a439.png";